var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('b-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Minnesota Nurse Aide Registry")]),_c('b-row',[_c('b-col',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.login}},[_vm._v("Login or Create Account")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }